import React from "react";
import PropTypes from "prop-types";
import { useMicroPipetteTooltip } from "./ControlTooltip.utils";
import {
  ControlButtons as TooltipButtons,
  ControlTooltip as Tooltip,
} from "../../../ControlTooltip";

export function ControlTooltip(props) {
  const { getButtonList } = useMicroPipetteTooltip(props);

  const getTooltipStyle = () => {
    const style = { top: "-20px", position: "absolute" };
    if (props.show) {
      style.top = "-45px";
    }
    return style;
  };

  const buttonList = getButtonList(props);

  return (
    <Tooltip
      showControls={props.show}
      label={props.label}
      tooltipStyle={getTooltipStyle()}
      hoverPlaceholderSize={props.hoverPlaceholderSize}
    >
      <TooltipButtons buttonList={buttonList} />
    </Tooltip>
  );
}

ControlTooltip.propTypes = {
  /**
   * Boolean to show/hide the Controls Tooltip Icons
   */
  show: PropTypes.bool,
  /**
   * Label to display on Tooltip
   */
  label: PropTypes.string,
  /**
   * Callback to OpenVolumeModal Icon Click
   */
  openVolumeModal: PropTypes.func,
  /**
   * Callback to open move menu modal
   */
  openMoveMenu: PropTypes.func,
  /**
   * Callback to Remove any attached tip on Micropipette
   */
  onRemoveTip: PropTypes.func,
  /**
   * hoverPlaceholderSize for the Component
   */
  hoverPlaceholderSize: PropTypes.number,
  /**
   * showMoveMenu to check moveMenu to display or not
   */
  showMoveMenu: PropTypes.bool,
  /**
   * Callback to set hamburger button ref for focus management
   */
  onSetHamburgerButtonRef: PropTypes.func,
};

ControlTooltip.defaultProps = {
  show: false,
  hoverPlaceholderSize: 0,
};
